<template>
  <div>
    <div class="fix-wrapper">
      <breadcrumb
        :crumbs="[$t('menu.replenishs'), $t('text.createBulk')]"
      ></breadcrumb>
      <div class="container">
        <el-form ref="formObjForm" :model="formObj" size="small">
          <div class="pd20">
            <fieldset class="mgb15">
              <legend>
                {{ $t("text.baseInfo") }}
                <span class="float-right">
                  {{ $t("order.hurry") }}
                  <el-checkbox v-model="formObj.hurry" />
                </span>
              </legend>
              <el-row>
                <el-col :span="8">
                  <el-form-item
                    :label="$t('replenish.serialNo')"
                    :prop="'serialNo'"
                    :rules="[
                      {
                        required: true,
                        validator: validateSerialNo,
                        trigger: 'blur',
                      },
                    ]"
                    label-width="80px"
                  >
                    <el-input
                      size="small"
                      v-model.trim="formObj.serialNo"
                      :placeholder="$t('prompt.alphabetNumberLine')"
                      clearable
                      @blur="blurbargainSerialNo()"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item
                    :label="$t('menu.shops')"
                    :prop="'shopId'"
                    :rules="[
                      {
                        required: true,
                        message: $t('rules.required', [$t('menu.shops')]),
                        trigger: 'blur',
                      },
                    ]"
                    label-width="80px"
                  >
                    <el-select
                      size="small"
                      v-model="formObj.shopId"
                      filterable
                      :disabled="Permit.createOrderFixShopDF()"
                    >
                      <el-option
                        v-for="shop in shops"
                        :key="shop.id"
                        :label="shop.name"
                        :value="shop.id"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item
                    :label="$t('text.handOverAt')"
                    :prop="'handOverAt'"
                    label-width="80px"
                  >
                    <el-date-picker
                      v-model="formObj.handOverAt"
                      type="date"
                      style="width: 100%"
                      :picker-options="pickerTodayAfterTime"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="16">
                  <el-form-item
                    :prop="'remark'"
                    :label="$t('text.batchRemark')"
                    label-width="80px"
                  >
                    <el-input
                      size="small"
                      v-model.trim="formObj.remark"
                      :placeholder="$t('text.batchRemark')"
                      @blur="blurRemark"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </fieldset>
            <fieldset class="mgb15">
              <legend>{{ $t("order.productInfo") }}</legend>
              <div
                class="flex flex-between mgb10"
                v-for="(item, index) in formObj.items"
                :key="index"
              >
                <!-- <div class="mgr10">
                  <thumbnail :images="item.images" />
                </div> -->

                <div class="flex-grow">
                  <el-row :gutter="20">
                    <el-col :span="19">
                      <el-row :gutter="20" class="mgb10">
                        <el-col :span="6">
                          <el-input
                            size="small"
                            v-model.trim="item.serialNo"
                            :placeholder="
                              $t('rules.mustFillSimple', [$t('order.serialNo')])
                            "
                            @blur="blurOrderSerialNo(index)"
                          ></el-input>
                        </el-col>
                        <el-col :span="6">
                          <el-autocomplete
                            size="small"
                            v-model.trim="item.productNo"
                            :fetch-suggestions="querySearchProductNo"
                            :data-index="index"
                            :trigger-on-focus="false"
                            style="width: 100%"
                            :placeholder="
                              $t('rules.mustFillSimple', [
                                $t('product.productNo'),
                              ])
                            "
                            @focus="getFoucs(index)"
                            @select="handleSelectProductNo(index)"
                          >
                            <template slot-scope="{ item }">
                              <div class="name">{{ item.productNo }}</div>
                              <span class="addr">
                                {{ item.productNoAlias }}
                              </span>
                            </template>
                          </el-autocomplete>
                        </el-col>
                        <el-col :span="6">
                          <el-autocomplete
                            size="small"
                            v-model.trim="item.color"
                            :fetch-suggestions="querySearchColor"
                            :placeholder="$t('product.color')"
                            style="width: 100%"
                            @focus="getFoucs(index)"
                            @select="handleSelectColor(index)"
                          ></el-autocomplete>
                        </el-col>
                        <el-col :span="6">
                          <el-autocomplete
                            size="small"
                            v-model.trim="item.size"
                            :fetch-suggestions="querySearchSize"
                            :placeholder="$t('product.size')"
                            style="width: 100%"
                            @focus="getFoucs(index)"
                            @select="handleSelectSize(index)"
                          ></el-autocomplete>
                        </el-col>
                      </el-row>
                      <el-row :gutter="20" class="mgb10">
                        <el-col :span="6">
                          <el-input
                            size="small"
                            v-model.trim="item.quantity"
                            :placeholder="
                              $t('rules.mustFillSimple', [$t('text.quantity')])
                            "
                          ></el-input>
                        </el-col>

                        <el-col :span="6" class="font10">
                          <div class="font10">
                            <template
                              v-if="item.categoryName != null"
                              class="mgr5"
                              >{{ item.categoryName }}</template
                            >
                            <template
                              v-if="item._productBrand != null"
                              class="mgr5"
                              >/{{ item._productBrand }}</template
                            >
                            <el-popover
                              v-if="Permit.extendModels().includes('wms')"
                              placement="right"
                              width="500"
                              trigger="click"
                              @show="getInvInfo(index)"
                            >
                              <vxe-table
                                :data="invInfos"
                                id="invInfosTable"
                                row-id="id"
                                ref="recordsTable"
                                class="recordsTable"
                                size="mini"
                                resizable
                                round
                                auto-resize
                                highlight-hover-row
                                :scroll-y="{ enabled: false }"
                              >
                                <vxe-table-column
                                  field="shopName"
                                  :title="$t('menu.warehouses')"
                                />
                                <vxe-table-column
                                  field="productNo"
                                  :title="$t('product.productNo')"
                                />
                                <vxe-table-column
                                  field="color"
                                  :title="$t('product.color')"
                                />
                                <vxe-table-column
                                  field="size"
                                  :title="$t('product.size')"
                                />
                                <vxe-table-column
                                  field="quantity"
                                  :title="$t('inventory.quantity')"
                                />
                                <vxe-table-column
                                  field="totalLock"
                                  :title="$t('inventory.totalLock')"
                                />
                              </vxe-table>
                              <small
                                slot="reference"
                                class="blue popover-reference"
                                >{{ $t("menu.inventories") }}</small
                              >
                            </el-popover>
                          </div>
                        </el-col>
                      </el-row>
                      <el-row :gutter="20">
                        <el-col :span="24">
                          <dropzone v-model="item.images" multiple />
                        </el-col>
                      </el-row>
                    </el-col>
                    <el-col :span="5">
                      <el-input
                        type="textarea"
                        :rows="7"
                        placeholder="备注"
                        v-model="item.remark"
                      ></el-input>
                    </el-col>
                  </el-row>
                </div>
                <div class="remove-order">
                  <el-button
                    type="text"
                    size="small"
                    @click="remove(index)"
                    v-if="index != 0"
                    >{{ $t("text.remove") }}</el-button
                  >
                </div>
              </div>
            </fieldset>
            <el-row :gutter="10">
              <el-col :span="6"
                >{{ $t("stock.totalQuantity") }}:
                {{ computeTotalQuantity() }}</el-col
              >
            </el-row>
            <div class="center">
              <el-button
                v-if="formObj.items.length < 10"
                type="info"
                @click="addMore"
                plain
                round
              >
                {{ $t("action.addProduct") }}
              </el-button>
              <span v-else class="orange">
                {{ $t("prompt.addMorePrompt") }}
              </span>
            </div>
          </div>
          <div class="form-footer">
            <el-button
              type="primary"
              size="medium"
              plain
              :loading="saveDoing"
              @click="saveSubmit"
              >{{ $t("text.submit") }}</el-button
            >
            <back-button />
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import { page } from "@/utils/mixins.js";
import Util from "@/utils/index.js";
import BackButton from "@/components/BackButton";
import Dropzone from "@/components/Dropzone";
import Shop from "@/api/shop.js";
import Bargain from "@/api/bargain.js";
import Order from "@/api/order.js";
import Product from "@/api/product.js";
import Inventory from "@/api/inventory.js";
import Category from "@/api/category.js";
import Size from "@/api/size.js";
import Color from "@/api/color.js";

function build() {
  return {
    serialNo: null, //
    productNo: null, //
    categoryId: null, //
    categoryName: null, //
    color: null, //
    colorImage: null, //
    size: null, //
    quantity: null, //
    productPrice: 0, //
    price: 0, //
    unit: null, //
    images: null, //
    specJson: null, //
    craftwork: null, //
    attachment: null, //
    remark: null, //
    currency: "CNY", //
    handOverAt: null, //
    hurry: false, //
    shopId: null, //
    discountRate: null, //
    //
    extraCharge: null,
    dealSuggest: null,
    confirmAt: null,
    innerSerialNo: null,
    customerProductNo: null,
    type: null,
    bargainId: null,
    settlementId: null,
    //
    _categorySizes: [],
    _productNoSizes: [],
    _productNoColors: [],
    //
    _oldSizeExplain: null,
    _productIntroduction: null,
    _productLabels: [],
    _productBrand: null,
  };
}
export default {
  mixins: [page],
  components: { BackButton, Dropzone },
  data() {
    var validateSerialNo = (rule, value, callback) => {
      const self = this;
      if (value === null || value === "") {
        callback(
          new Error(self.$t("rules.required", [self.$t("bargain.serialNo")]))
        );
        return;
      }
      if (!Util.regexAlphabetNumberLine(value)) {
        callback(new Error(self.$t("prompt.regexAlphabetNumberLine")));
        return;
      }
      Bargain.findBySerialNo({ serialNo: value }).then(function (res) {
        if (res.data.code === 200) {
          callback(
            new Error(self.$t("rules.exist", [self.$t("bargain.serialNo")]))
          );
        } else {
          Order.findBySerialNo({ serialNo: value }).then(function (res) {
            if (res.data.code === 200) {
              callback(
                new Error(self.$t("rules.exist", [self.$t("order.serialNo")]))
              );
            } else {
              callback();
            }
          });
        }
      });
    };
    return {
      pickerTodayAfterTime: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        },
      },
      validateSerialNo: validateSerialNo,
      Util: Util,
      shops: [],
      categories: [],
      sizes: [],
      colors: [],
      formObj: {
        hurry: false,
        serialNo: "BH" + Util.serialNo(),
        shopId: null,
        handOverAt: null,
        items: [build(), build(), build()],
        remark: null,
      },
      products: [],
      invInfos: [],
      productsLoading: false,
      saveDoing: false,
    };
  },

  computed: {},
  created() {
    const self = this;
    self.blurbargainSerialNo();

    axios
      .all([
        Shop.findByTenantId(),
        Category.findByTenantId(),
        Size.findByTenantId(),
        Color.findByTenantId(),
      ])
      .then(
        axios.spread(function (shops, categories, sizes, colors) {
          if (shops.status === 200) {
            self.shops = shops.data;
            if (
              self.shops.find(
                (s) => s.id == self.Permit.currentUser().shopId
              ) != null
            ) {
              self.formObj.shopId = self.Permit.currentUser().shopId;
            }
          } else {
            self.sysError();
          }
          if (categories.status === 200) {
            self.categories = categories.data;
          } else {
            self.sysError();
          }
          if (sizes.status === 200) {
            self.sizes = sizes.data;
          } else {
            self.sysError();
          }
          if (colors.status === 200) {
            self.colors = colors.data;
          } else {
            self.sysError();
          }
        })
      );
  },
  methods: {
    blurRemark() {
      const self = this;
      for (const item of self.formObj.items) {
        if (item.remark == null || item.remark == "") {
          item.remark = self.formObj.remark;
        } else {
          item.remark = item.remark + "\n" + self.formObj.remark;
        }
      }
    },
    computeTotalQuantity() {
      let totalQuantity = 0;
      if (this.formObj.items.length !== 0) {
        for (const item of this.formObj.items) {
          totalQuantity = totalQuantity + Number(item.quantity);
        }
      }
      return totalQuantity;
    },

    blurbargainSerialNo() {
      const self = this;
      if (self.formObj.items.length === 1) {
        self.formObj.items[0].serialNo = self.formObj.serialNo;
      } else {
        for (let i = 0; i < self.formObj.items.length; i++) {
          self.formObj.items[i].serialNo =
            self.formObj.serialNo + "-" + (i + 1);
        }
      }
    },
    //
    addMore() {
      const newBuild = JSON.parse(JSON.stringify(build()));
      newBuild.serialNo =
        this.formObj.serialNo + "-" + (this.formObj.items.length + 1);
      this.formObj.items.push(newBuild);
    },
    remove(idx) {
      this.formObj.items.splice(idx, 1);
    },

    //
    blurOrderSerialNo(index) {
      const self = this;
      if (
        self.formObj.items[index].serialNo === null ||
        self.formObj.items[index].serialNo === ""
      ) {
        self.$message({
          message: self.$t("rules.required", [self.$t("replenish.serialNo")]),
          type: "warning",
        });
        return;
      }
      if (!Util.regexAlphabetNumberLine(self.formObj.items[index].serialNo)) {
        self.$message({
          message: self.$t("prompt.regexAlphabetNumberLine"),
          type: "warning",
        });
        return;
      }
      // 前台本地过滤
      const iis = self.formObj.items.filter(function (ii) {
        return ii.serialNo === self.formObj.items[index].serialNo;
      });
      if (iis.length > 1) {
        self.$message({
          message: self.$t("rules.exist", [self.$t("order.serialNo")]),
          type: "warning",
        });
        self.formObj.items[index].serialNo = null;
        return;
      }
      Order.findBySerialNo({
        serialNo: self.formObj.items[index].serialNo,
      }).then(function (res) {
        if (res.data.code === 200) {
          self.$message({
            message: self.$t("rules.exist", [self.$t("order.serialNo")]),
            type: "warning",
          });
          self.formObj.items[index].serialNo = null;
        }
      });
    },

    // 货号
    querySearchProductNo(queryString, cb) {
      const self = this;
      if (queryString == null || queryString.length < 1) {
        return;
      }
      Product.vagueFindByProductNo({ productNo: queryString }).then(function (
        res
      ) {
        const ps = res.data;
        ps.forEach((p) => (p.value = p.productNo));
        self.products = ps;
        cb(self.products);
      });
    },
    handleSelectProductNo(idx) {
      const self = this;
      const item = self.products.find(
        (p) => p.productNo === self.formObj.items[idx].productNo
      );
      self.formObj.items[idx].productNo = item.productNo;
      self.formObj.items[idx].categoryId = item.categoryId;
      self.formObj.items[idx].categoryName = item.categoryName;
      self.selsectCategory(idx);
      self.formObj.items[idx].color = null;
      self.formObj.items[idx].colorImage = null;
      self.formObj.items[idx].size = null;
      self.formObj.items[idx].images = item.images;
      self.formObj.items[idx].unit = item.unit;
      self.formObj.items[idx].craftwork = item.craftwork;
      self.formObj.items[idx].remark =
        (self.formObj.items[idx].remark || "") + (item.introduction || "");
      self.formObj.items[idx].discountRate = null;
      self.formObj.items[idx]._productNoColors = item.colors;
      self.formObj.items[idx]._productNoSizes = item.sizes;
      self.formObj.items[idx]._productIntroduction = item.introduction;
      self.formObj.items[idx]._productLabels = item.productLabels;
      self.formObj.items[idx]._productBrand = item.brand;
      //
    },
    //
    selsectCategory(idx) {
      const self = this;
      if (self.formObj.items[idx].categoryId === "") {
        self.formObj.items[idx].categoryId = null;
      }
      self.formObj.items[idx]._categorySizes = [];
      if (
        self.formObj.items[idx].categoryId != null &&
        self.formObj.items[idx].categoryId !== ""
      ) {
        const selsectCategoryObj = self.categories.find(
          (c) => c.id === self.formObj.items[idx].categoryId
        );
        if (
          selsectCategoryObj &&
          selsectCategoryObj.sizes != null &&
          selsectCategoryObj.sizes.length !== 0
        ) {
          self.formObj.items[idx]._categorySizes = selsectCategoryObj.sizes;
        }
      }
    },
    //
    // 颜色
    querySearchColor(queryString, cb) {
      const self = this;
      const colors =
        self.formObj.items[self.currentIndex]._productNoColors.length !== 0
          ? self.formObj.items[self.currentIndex]._productNoColors.map((pc) => {
              return { value: pc };
            })
          : self.colors.map((c) => {
              return { value: c.name };
            });
      if (queryString == null) {
        cb(colors);
      } else {
        cb(colors.filter((c) => c.value.indexOf(queryString) !== -1));
      }
    },
    handleSelectColor(idx) {
      this.formObj.items[idx].color = Util.jyTrim(
        this.formObj.items[idx].color
      );
    },
    // 规格
    querySearchSize(queryString, cb) {
      const self = this;
      let sizes = [];
      if (self.formObj.items[self.currentIndex]._productNoSizes.length !== 0) {
        sizes = self.formObj.items[self.currentIndex]._productNoSizes.map(
          (pc) => {
            return { value: pc };
          }
        );
      } else {
        if (self.formObj.items[self.currentIndex]._categorySizes.length !== 0) {
          sizes = self.formObj.items[self.currentIndex]._categorySizes.map(
            (c) => {
              return { value: c.name, explain: c.explain };
            }
          );
        } else {
          sizes = self.sizes.map((c) => {
            return { value: c.name, explain: c.explain };
          });
        }
      }
      if (queryString == null) {
        cb(sizes);
      } else {
        cb(sizes.filter((c) => c.value.indexOf(queryString) !== -1));
      }
    },
    handleSelectSize(idx) {
      const self = this;
      self.formObj.items[idx].size = Util.jyTrim(self.formObj.items[idx].size);
      self.computeRemark(idx);
    },
    computeRemark(idx) {
      const self = this;
      const sizeObj = self.sizes.find(
        (s) => s.name === self.formObj.items[idx].size
      );
      // 替换已经有的尺码说明
      if (
        self.formObj.items[idx].remark != null &&
        self.formObj.items[idx]._oldSizeExplain != null
      ) {
        self.formObj.items[idx].remark = self.formObj.items[idx].remark.replace(
          ";【" + self.formObj.items[idx]._oldSizeExplain + "】",
          ""
        );
        self.formObj.items[idx].remark = self.formObj.items[idx].remark.replace(
          "<br/>【" + self.formObj.items[idx]._oldSizeExplain + "】",
          ""
        );
        self.formObj.items[idx].remark = self.formObj.items[idx].remark.replace(
          "【" + self.formObj.items[idx]._oldSizeExplain + "】",
          ""
        );
        self.formObj.items[idx].remark = self.formObj.items[idx].remark.replace(
          self.formObj.items[idx]._oldSizeExplain,
          ""
        );
      }
      // 加入新的尺码说明
      if (sizeObj != null && sizeObj.explain != null && sizeObj.explain != "") {
        if (
          self.formObj.items[idx].remark !== null &&
          self.formObj.items[idx].remark != ""
        ) {
          self.formObj.items[idx].remark =
            self.formObj.items[idx].remark + ";【" + sizeObj.explain + "】";
        } else {
          self.formObj.items[idx].remark = "【" + sizeObj.explain + "】";
        }
        self.formObj.items[idx]._oldSizeExplain = sizeObj.explain;
      }
    },
    getFoucs(index) {
      const self = this;
      self.currentIndex = index;
    },
    //
    getInvInfo(idx) {
      const self = this;
      self.invInfos = [];
      if (
        self.formObj.items[idx].productNo != null &&
        self.formObj.items[idx].productNo != ""
      ) {
        const obj = {
          productNo: self.formObj.items[idx].productNo,
          color: self.formObj.items[idx].color,
          size: self.formObj.items[idx].size,
        };
        Inventory.findByProductInfoWithoutShop(obj).then(function (res) {
          if (res.status === 200) {
            self.invInfos = res.data;
          } else {
            self.sysError();
          }
        });
      }
    },
    //
    saveSubmit() {
      let self = this;
      self.$refs.formObjForm.validate((valid) => {
        if (valid) {
          const items = self.formObj.items.filter(
            (item) =>
              item.productNo != null &&
              item.productNo !== "" &&
              item.quantity != null &&
              item.quantity != ""
          );
          if (items.length === 0) {
            this.$message({
              message: self.$t("prompt.atLeastOneDataFill"),
              type: "warning",
            });
            return;
          }
          for (const item of items) {
            if (!Util.regexQuantity(item.quantity) || item.quantity == "0") {
              self.$message({
                message: self.$t("rules.regex", [
                  self.$t("inventory.quantity"),
                ]),
                type: "warning",
              });
              return;
            }
            item.shopId = self.formObj.shopId;
            item.shopName = self.formObj.shopName;
            item.hurry = self.formObj.hurry;
            if (self.formObj.handOverAt != null) {
              item.handOverAt = Util.formatDate(self.formObj.handOverAt);
            }
          }
          if (items.length === 1) {
            items[0].serialNo = self.formObj.serialNo;
          }
          self.saveDoing = true;
          Order.batchReplenish(items).then(function (res) {
            if (res.status === 200) {
              self.saveDoing = false;
              self.$message({
                message: self.$t("prompt.addSuccess"),
                type: "success",
              });
              self.$router.push({ name: "omsReplenishs" });
            } else {
              self.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style scoped>
.remove-order {
  width: 50px;
  text-align: center;
  line-height: 80px;
}
</style>